export default __webpack_public_path__ + "assets/859f3184c17e95cd8b7c118aa8bcf061.png";